export default __webpack_public_path__ + "static/media/disabled-collection-icon.e18660aa.svg";